import Vue from "vue";
import VueRouter, { NavigationGuardNext, Route } from "vue-router";
import HomeView from "../views/home/HomeView.vue";
import PartnersView from "@/views/partners/PartnersView.vue";
import PartnerStoreView from "@/views/partners/PartnerStoreView.vue";
import TransactionView from "@/views/transactions/TransactionsView.vue";
import Login from "../views/login/Login.vue";
import ForgotPassword from "../views/forgotPassword/ForgotPassword.vue";
import FirstAccessPassword from "../views/firstAccess/FirstAccessPassword.vue";
import AssociatesView from "@/views/associates/AssociatesView.vue";
import BankDataView from "@/views/bank/BankDataView.vue";
import ReferralSignupView from "@/views/referral/ReferralSignupView.vue";
import store from "@/store";

Vue.use(VueRouter);

const PUBLIC_ROUTES = new Set(["login", "forgotPassword", "referralSignup"]);

const getAccessToken = (): string | false => {
  try {
    const userData = JSON.parse(String(localStorage.getItem("tokens")));
    return userData?.accessToken || false;
  } catch {
    return false;
  }
};

const authGuard = async (
  to: Route,
  _from: Route,
  next: NavigationGuardNext,
) => {
  const token = getAccessToken();

  if (PUBLIC_ROUTES.has(String(to.name))) {
    if (token && to.name !== "referralSignup") {
      next("/");
      return;
    }
    next();
    return;
  }

  if (!token) {
    next("/login");
    return;
  }

  if (!store.state.session) {
    try {
      await store.dispatch("loadSession");
    } catch {
      store.dispatch("clearSession");
      localStorage.removeItem("tokens");
      next("/login");
      return;
    }
  }

  next();
};

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/first-access",
    name: "firstAccess",
    component: FirstAccessPassword,
  },
  {
    path: "/indicacao/:code",
    name: "referralSignup",
    component: ReferralSignupView,
  },
  {
    path: "/partners",
    name: "partners",
    component: PartnersView,
  },
  {
    path: "/partners/:id",
    name: "partnerStore",
    component: PartnerStoreView,
  },
  {
    path: "/associates",
    name: "associates",
    component: AssociatesView,
  },
  {
    path: "/transactions",
    name: "transactions",
    component: TransactionView,
  },
  {
    path: "/bank-account",
    name: "bankAccount",
    component: BankDataView,
  },
  {
    path: "/premium",
    redirect: "/associates",
  },
  {
    path: "/premium/network",
    redirect: "/associates",
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { compactShell: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(authGuard);

export default router;
